import React, { type ReactNode } from "react";
import { Card, VStack, Text } from "@astryxdesign/core";

export interface AuthCardProps {
  /** One line under the brand wordmark saying what this screen is for. */
  subtitle: string;
  children: ReactNode;
  /** The brand name displayed at the top of the card. @default "ContxtIQ" */
  title?: string;
}

/**
 * The card every signed-out screen sits in: a brand wordmark and a subtitle,
 * then the screen's content. Must be rendered inside an `AuthLayout`.
 */
const AuthCard = ({ subtitle, children, title = "ContxtIQ" }: AuthCardProps): React.ReactElement => {
  return (
    <Card padding={8} width={360} maxWidth="100%" elevation="high">
      <VStack gap={8}>
        <VStack gap={4} align="center">
          <Text as="h1" type="display-3" weight="semibold" hasCapsize>
            {title}
          </Text>
          <Text type="body" color="secondary" hasCapsize>
            {subtitle}
          </Text>
        </VStack>
        {children}
      </VStack>
    </Card>
  );
};

export default AuthCard;
